import { t } from "i18next";

import ElementPopup from "./Customization/ElementPopup";
import FloatingPopup from "./Customization/FloatingPopup";
import Iframe from "./Customization/Iframe";
import Inline from "./Customization/Inline";
import { InlineEmbedIcon, FloatingPopupIcon, ElementPopupIcon } from "./Icons";

export const EMBED_OPTIONS = {
  INLINE: "inline",
  FLOATING_POPUP: "floatingPopup",
  ELEMENT_POPUP: "elementPopup",
  IFRAME: "iframe",
};

export const EMBED_ICONS = {
  [EMBED_OPTIONS.INLINE]: InlineEmbedIcon,
  [EMBED_OPTIONS.FLOATING_POPUP]: FloatingPopupIcon,
  [EMBED_OPTIONS.ELEMENT_POPUP]: ElementPopupIcon,
  [EMBED_OPTIONS.IFRAME]: InlineEmbedIcon,
};

export const DEFAULT_CUSTOMIZATION = {
  [EMBED_OPTIONS.INLINE]: {
    width: 100,
    height: 100,
    elementSelector: "inline-embed-container",
  },
  [EMBED_OPTIONS.FLOATING_POPUP]: {
    showIcon: false,
    btnText: "Open",
    btnColor: "#008068",
    btnTextColor: "#fff",
    btnPosition: "bottomRight",
  },
  [EMBED_OPTIONS.ELEMENT_POPUP]: {
    elementSelector: "open-popup-button",
  },
  [EMBED_OPTIONS.IFRAME]: {
    height: 100,
    width: 100,
    iframeTitle: "Iframe embed",
  },
};

export const EMBED_CUSTOMIZATION_COMPONENTS = {
  [EMBED_OPTIONS.INLINE]: Inline,
  [EMBED_OPTIONS.FLOATING_POPUP]: FloatingPopup,
  [EMBED_OPTIONS.ELEMENT_POPUP]: ElementPopup,
  [EMBED_OPTIONS.IFRAME]: Iframe,
};

export const EMBED_TITLES = {
  [EMBED_OPTIONS.INLINE]: t("neetoMolecules.productEmbed.inline.title"),
  [EMBED_OPTIONS.FLOATING_POPUP]: t(
    "neetoMolecules.productEmbed.floatingPopup.title"
  ),
  [EMBED_OPTIONS.ELEMENT_POPUP]: t(
    "neetoMolecules.productEmbed.elementPopup.title"
  ),
  [EMBED_OPTIONS.IFRAME]: t("neetoMolecules.productEmbed.iframe.title"),
};

export const SUPPORTED_LANGUAGES = [
  { value: "html", label: t("neetoMolecules.productEmbed.language.html") },
  {
    value: "react",
    label: t("neetoMolecules.productEmbed.language.react"),
  },
];

export const SCRIPT_ID = "embed-script";

export const TAB_STRING = "    ";

export const SWITCH_OPTIONS = {
  dynamicHeight: {
    label: t("neetoMolecules.productEmbed.dynamicHeight"),
  },
  hideTitle: { label: t("neetoMolecules.productEmbed.hideTitle") },
  alignContentLeft: {
    label: t("neetoMolecules.productEmbed.alignContentLeft"),
  },
  transparentBackground: {
    label: t("neetoMolecules.productEmbed.transparentBackground"),
  },
};
